const firebaseConfig = {
    apiKey: "AIzaSyAUQUxej9_0uSq8xkmpqArriMMu1ippQ9A",
    authDomain: "tourism-related-website.firebaseapp.com",
    projectId: "tourism-related-website",
    storageBucket: "tourism-related-website.appspot.com",
    messagingSenderId: "291772672920",
    appId: "1:291772672920:web:167e816750d96bd56099ed"
  };
  export default firebaseConfig;


 